

const RadioGroup = ({ 
    label, 
    name, 
    value, 
    options, 
    onChange, 
    color, 
    textColor,
    fullWidth = false
  }) => (
    <div style={{
        ...radioGroupStyle,
        flex: '1 1 0'
      }}>
      <label style={labelStyle(textColor)}>{label}</label>
      <div style={{ display: 'flex', gap: '32px',justifyContent: 'center' }}>
        {options.map(option => (
          <div 
            key={option} 
            style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
            onClick={() => onChange(option)}
          >
            <div style={radioStyle(color, value === (option === 'Yes'))}>
              {value === (option === 'Yes') && <div style={radioInnerStyle} />}
            </div>
            <span style={radioLabelStyle(textColor)}>{option}</span>
          </div>
        ))}
      </div>
    </div>
  );

  export default RadioGroup;

  const radioGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    // width: '100%'
  };

  const radioLabelStyle = (color) => ({
    color,
    fontSize: '16px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '400',
    lineHeight: '20px'
  });

  const radioStyle = (color, checked) => ({
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    outline: `1.5px solid ${color}`,
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: checked ? color : 'transparent'
  });

  const labelStyle = (color) => ({
    color,
    fontSize: '12px',
    fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
    fontWeight: '400'
  });

  const radioInnerStyle = {
    position: 'absolute',
    top: '4px',
    left: '4px',
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: 'white'
  };